import type { CmsLink } from '../../cms'
import type { CroppedImage } from '../../cms/types/croppedImage'

export class PageBase {
    public name: string
    public url: string
    public urlSegment: string
    public nodeId: number
    public alias: string
    public createDate: string
    public updateDate: string

    // Title
    public pageTitle: string
    public hideTitle: boolean

    // SEO stuff
    public seoImage: CroppedImage
    public metaKeywords: string
    public metaDescription: string
    public seoPageTitle: string
    public oGType: string
    public oGLocale: string
    public twitterCard: string
    public seoUrl: string

    // Robots meta
    public robotsNoFollow: boolean
    public robotsNoIndex: boolean

    // Canonical
    public masterCanonicalUrl: CmsLink | null
    public excludeCanonicalUrl: boolean

    /**
     * getter for `pageTitle`, uses node `name` if `pageTitle` is not set
     */
    get pageHeader(): string {
        return this.pageTitle || this.name
    }
}
